export interface ClassifiedAd {
  id: number;
  title: string;
  titleKey?: string;
  description: string;
  descriptionKey?: string;
  category: AdCategory;
  price?: number;
  currency?: string;
  author: string;
  authorKey?: string;
  authorId: number;
  createdDate: Date;
  updatedDate: Date;
  isActive: boolean;
  images?: string[];
  contactInfo?: string;
  location?: string;
  locationKey?: string;
}

export enum AdCategory {
  FURNITURE = 'furniture',
  ELECTRONICS = 'electronics',
  VEHICLES = 'vehicles',
  REAL_ESTATE = 'real_estate',
  SERVICES = 'services',
  OTHER = 'other',
}
